/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {WechatyComponent as ɵa} from './src/wechaty/wechaty.component';